import React, { useState, useContext } from "react";
import {
  CssBaseline,
  Box,
  useMediaQuery,
  CircularProgress,
  Typography,
} from "@mui/material";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./Component/Header/header";
import Sidebar from "./Component/Sidebar/sidebar";
import Review_batches from "./Component/Review batches/review_batches";
import Approval from "./Component/Approval/approval";
import Vendor_name from "./Component/Vandor Name/vendor_name";
import InvoiceTemplate from "./Component/InvoiceTemplate/Invoice_template";

import HoldCase from "./Component/Hold Cases/HoldCases";
import Concern from "./Component/Concern/concern";
import BankReject from "./Component/BankReject/BankReject";
import Login from "./Component/Login/Login";
import Unauthorized from "./Component/Unauthorized";
import ProtectedRoute from "./Component/ProtectedRoute";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import { AuthContext } from "./context/AuthContext";
import EditData from "./Component/Review batches/EditData";
import PartialApproval from "./Component/PartialApproval/PartialApproval";
import VendorBatchPage from "./Component/Vandor Name/VendorBatchPage";
import ReviewBatchPage from "./Component/Review batches/ReviewBatchPage";
import ApprovalBatchPage from "./Component/Approval/ApprovalBatchPage";
import GetNetworkReject from "./Component/getnetworkReject/GetNetworkReject";
import SendBackByApproval from "./Component/SendBackByApproval/SendBackByApproval";
import PartialDetailPage from "./Component/PartialApproval/PartialDetailPage";
import SendbackDetailPage from "./Component/SendBackByApproval/SendBackDetailPage";
import RejectedCasePage from "./Component/ReajectedCases/RejectedCasePage";
import Reajectedcases from "./Component/ReajectedCases/Reajectedcases";
import QueryCases from "./Component/Query case/QueryCases";
import QueryCasePage from "./Component/Query case/QuaryCasePage";
import HoldCasesPage from "./Component/Hold Cases/HoldCasesPage";
import NetworkRejectPage from "./Component/getnetworkReject/NetworkRejectPage";
import CompletedBatches from "./Component/completedBatch/CompletedBatches";
import GlobalSearchResult from "./Component/GlobalSearch";
import Dashboard from "./Component/Dashboard";
import ApprovedBatches from "./Component/ApprovedBatches/APprovedBatches";
import ApprovedBatchData from "./Component/ApprovedBatches/ApprovedBatchDetails";
import LogPage from "./Component/LogPage";
import VendorMIS from "./Component/MIS/VendorMIS";
import InvoiceMIS from "./Component/MIS/InvoiceMIS";
import BatchMIS from "./Component/MIS/BatchMIS";
import PaymentMIS from "./Component/MIS/PaymentMIS";
import VendorInvoices from "./Component/MIS/VendorInvoices";
import OPenCases from "./Component/MIS/OPenCases";
import PendingPaymentMIS from "./Component/MIS/PendingPaymentMIS";
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import RemarksLogsPage from "./Component/RemarksLogPage";

const InactivityHandler = () => {
  const navigate = useNavigate();
  let timeout;

const resetTimer = () => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    navigate("/");
  }, 6 * 60 * 60 * 1000); 
};
  useEffect(() => {
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keypress", resetTimer);
    window.addEventListener("scroll", resetTimer);
    window.addEventListener("click", resetTimer);

    resetTimer();

    return () => {

      clearTimeout(timeout);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keypress", resetTimer);
      window.removeEventListener("scroll", resetTimer);
      window.removeEventListener("click", resetTimer);
    };
  }, []);

  return null;
};
function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { loading, user } = useContext(AuthContext); // Access loading state

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  // Render a loading indicator while checking localStorage
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <CssBaseline />
      <InactivityHandler />
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Protected Routes */}
        <Route
          path="/invoice"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      overflowX: "scroll",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <Review_batches />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]} // Allow both roles
            />
          }
        />
        <Route
          path="/ReviewBatchPage"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      overflowX: "scroll",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <ReviewBatchPage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]} // Allow both roles
            />
          }
        />
        <Route
          path="/approval"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <Approval />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/approvalBatchPage"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <ApprovalBatchPage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/vendor-name"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <Vendor_name />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]} // Restrict to NetworkAdmin
            />
          }
        />
        <Route
          path="/vendorBatchPage"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <VendorBatchPage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/invoice-template"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <InvoiceTemplate />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/Edit-data"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <EditData />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/rejected-cases"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <Reajectedcases />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/reajectedcasesPage"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <RejectedCasePage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/query-case"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <QueryCases />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/queryCasesPage"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <QueryCasePage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/hold-case"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <HoldCase />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/completed-batches"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <CompletedBatches />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/holdCasesPage"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <HoldCasesPage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/concern"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <Concern />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/bankReject"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <BankReject />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/partialApproval"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <PartialApproval />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/partialDetailPage"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <PartialDetailPage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/sendBackByapproval"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <SendBackByApproval />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/sendBackdetailPage"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <SendbackDetailPage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/networkRejectedCases"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    {/* <GetNetworkReject /> */}
                    
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/networkRejectPage"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <NetworkRejectPage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/ApprovedBatches"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <ApprovedBatches />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin", "Finance", "finance"]}
            />
          }
        />
        <Route
          path="/ApprovedBatchData"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <ApprovedBatchData />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin", "Finance", "finance"]}
            />
          }
        />
        <Route
          path="/global-search-result"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <GlobalSearchResult />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/logs/:batchNo"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <LogPage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
          <Route
          path="/Remarks&Logs/:aa_number"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <RemarksLogsPage />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/Dashboard"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <Dashboard />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/pendingPaymentMIS"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <VendorMIS />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/paidPaymentMIS"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <InvoiceMIS />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/UTRpaymentMIS"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <BatchMIS />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/rawdataMIS"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <PaymentMIS />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/vendor-invoices/:vendorName"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <VendorInvoices />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route
          path="/UnbilledCases"
          element={
            <ProtectedRoute
              element={
                <>
                  <Header open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Sidebar open={sidebarOpen} toggleSidebar={toggleSidebar} />
                  <Box
                    component="main"
                    sx={{
                      flexGrow: 1,
                      marginLeft: sidebarOpen && !isMobile ? "0px" : 0,
                      width: "100%",
                      marginTop: "64px",
                      transition: "margin 0.3s ease-in-out",
                    }}
                  >
                    <OPenCases />
                  </Box>
                </>
              }
              allowedRoles={["NetworkSubAdmin","ServiceProvider", "NetworkAdmin"]}
            />
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Box>
  );
}

export default App;
